const allPaySliptable = { data: [], loading: true };

export const GetAllPaySlipTable = (state = allPaySliptable, action) => {
    switch (action.type) {

        case "get_allpaysliptable":
            return {
                data: action.payload,
                loading: action.loading
            }
        default:
            return state;
    }


}